import axios from "axios";
import { HOST_API_KEY } from "../../../config";

const PROFILE_REQUEST_TIMEOUT_MS = 5000;

const getAuthHeaders = () => {
  if (typeof window === "undefined") return {};

  const token = localStorage.getItem("jwtToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getUserProfileInfoById = async (id) => {
  const request = await axios.get(`${HOST_API_KEY}/user/profile/${id}`, {
    timeout: PROFILE_REQUEST_TIMEOUT_MS,
  });
  return request?.data;
};

export const updateUserProfileInfo = async (id, data) => {
  const request = await axios.put(`${HOST_API_KEY}/user/update/${id}`, data, {
    timeout: 10000,
    headers: getAuthHeaders(),
  });
  return request?.data;
};

export const updateUserProfilePicture = async (id, data) => {
  const request = await axios.put(
    `${HOST_API_KEY}/user/${id}/profile-picture`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 15000,
    }
  );
  return request?.data;
};

export const updateUserPassword = async (id, data) => {
  const request = await axios.put(`${HOST_API_KEY}/user/${id}/password`, data);
  return request?.data;
};

export const updateUserLocationStatus = async (data) => {
  const request = await axios.put(`${HOST_API_KEY}/user/location-enable-disable`, data,
    {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("jwtToken"),
      },
    }
  );
  return request?.data;
};

export const createPasswordResetOTP = async (id, data) => {
  const request = await axios.post(
    `${HOST_API_KEY}/user/password-reset-otp/${id}`,
    data
  );
  return request?.data;
};
